var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: _vm.closeMask,
        mousewheel: function($event) {
          $event.preventDefault()
          return _vm.changePicSize.apply(null, arguments)
        }
      }
    },
    [
      _c("img", {
        ref: "img",
        style: _vm.getImgSize,
        attrs: { src: _vm.imgSrc, alt: "" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-265e69df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-265e69df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pic-mask.vue
// module id = null
// module chunks = 